// extracted by mini-css-extract-plugin
export default {"wrapper":"gy-z","viewport":"hy-z","container":"iy-z","slide":"jy-z"};